import store from "../store";
import {getDPM} from "./getAreaCorrected";

export const getTextureScale = async function (translatedScale, distance, textureSRC, realTextureSize) {

    let dpm = await getDPM(distance, translatedScale);
    let getSizePromise = new Promise((resolve)=>{
        let img = new Image();
        img.src = store.getters['projectConfiguration/GENERATE_URL'](textureSRC);
        img.onload = () => {
            resolve({width: img.naturalWidth, height: img.naturalHeight})
        }
    })
    let textureSize = await getSizePromise;
    let textureCoef = 0.1;
    if (realTextureSize.height) {
        let textureDPM = textureSize.height / realTextureSize.height;
        textureCoef = dpm/textureDPM;
    }
    return textureCoef;
}
